import { useDorisData } from 'src/utils/Hooks/useDorisData';

export interface GetTrafficByTypeParams {
  metricType: string;
  fieldName: string;
  retailerId: string;
  categoryIds?: number[];
  segmentIds?: string[];
  startWeekId?: number;
  endWeekId?: number;
  minRetailPrice?: number;
  maxRetailPrice?: number;
  resultCount?: number;
  brandIds?: number[];
}

export interface TrafficRecord {
  fieldKey: number | string;
  value: number;
  metadata?: any;
  brandId?: number;
}

export interface TrafficResponse {
  fieldName: string;
  records: TrafficRecord[];
  debug?: {
    query: string;
    queryExecutionTime: number;
    queryContextCreationTime: number;
    isCacheHit: boolean;
    cacheResponseTime: number;
    topicGroupAnnotationTime: number;
  };
}

export interface UseGetTrafficByTypeProps {
  metricType: string;
  fieldName: string;
  resultCount?: number;
  queryKey: string;
  brandIds?: number[];
  categoryIds?: number[];
  enabled?: boolean;
  additionalParams?: Record<string, any>;
}

/**
 * A hook to fetch traffic data by type (brand, keyword)
 * Uses the GetTrafficByType endpoint with entity filters automatically applied
 */
export const useGetTrafficByType = ({
  metricType,
  fieldName,
  resultCount = 100,
  queryKey,
  brandIds,
  categoryIds,
  enabled = true,
  additionalParams = {}
}: UseGetTrafficByTypeProps) => {
  // Use the generic useDorisData hook
  const { data, isLoading, error } = useDorisData<TrafficResponse>({
    methodName: 'GetTrafficByType',
    metricType,
    fieldName,
    queryKey,
    resultCount,
    brandIds,
    categoryIds,
    enabled,
    additionalParams,
    queryOptions: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 10 * 1000
    }
  });

  return {
    data,
    isLoading,
    error
  };
};
